import { connect } from "react-redux";
import React, { useEffect, useState } from "react";
import NoFooterModal from "../../Common/NoFooterModal";
import Button from "sushiweb/Button";
import { BottomSectionModal } from "../../../constants/assets/containers";
import Label from "sushiweb/Label";
import Input from "sushiweb/InputTypes/Input";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import { entityTypeList } from "../CreateFilters";
import {
  filterObj,
  isObjectAllEntriesPresent,
  isObjectStateEmpty,
  isValNull,
} from "../../../utils";
import { bindActionCreators } from "redux";
import moment from "moment";
import {
  getCapacityChangeRequestData,
  setEntityList,
} from "../../../store/actions/CapacityChange";
import { resetStateSlot } from "../../../store/actions/Slots";
import { setActiveFilters } from "../../../store/actions/CapacityChange";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";

export const REQUEST_STATUSES = [
  { label: "ALL", id: 0 },
  { label: "REJECTED", id: 1 },
  { label: "APPROVED", id: 2 },
  { label: "REQUESTED", id: 3 },
  { label: "PROCESSING", id: 4 },
];

const ViewFilters = ({
  handleModalClose,
  userAttributes,
  getCapacityChangeRequests,
  carrierList,
  activeFilters,
  setEntityList,
  entityList,
  setActiveFilters,
  allMenuActions,
  resetStateSlot,
  resetPageCount,
}) => {
  const [initialState, setInitialState] = useState({
    entity: {
      zone_id: "",
      zone_name: "",
    },
    city: {
      id: "",
      name: "",
      zones: [],
    },
    entity_type: "",
    status: "",
    start_date: moment(new Date()).format("YYYY-MM-DD"),
    end_date: moment(new Date()).add(4, "days").format("YYYY-MM-DD"),
    request_id: "",
    carrier_type: "",
    date: "",
  });
  const [cityList, setCityList] = useState([]);

  const allActions = MenuActionsMappings[MenuNames.MANUAL_SLOT_CAPACITY_UPDATE];

  useEffect(() => {
    setInitialState({
      city: !isValNull(activeFilters.city)
        ? activeFilters.city
        : {
            id: "",
            name: "",
            zones: [],
          },
      entity: !isValNull(activeFilters.entity)
        ? activeFilters.entity
        : {
            zone_id: "",
            zone_name: "",
          },
      carrier_type: !isValNull(activeFilters.carrier_type)
        ? activeFilters.carrier_type
        : "",
      start_date: !isValNull(activeFilters.start_date)
        ? moment(activeFilters.start_date).format("YYYY-MM-DD")
        : initialState.start_date,
      entity_type: !isValNull(activeFilters.entity_type)
        ? getValue("entity_type", activeFilters.entity_type)
        : "",
      status: !isValNull(activeFilters.end_date)
        ? activeFilters.status
        : REQUEST_STATUSES[0].label,
      end_date: !isValNull(activeFilters.end_date)
        ? moment(activeFilters.end_date).format("YYYY-MM-DD")
        : initialState.end_date,
      request_id: !isValNull(activeFilters.request_id)
        ? activeFilters.request_id
        : initialState.request_id,
    });
  }, []);

  useEffect(() => {
    const cities = [];
    (userAttributes || []).forEach((element) => {
      cities.push({
        id: element.city_id,
        name: element.city_name,
        zones: element.zones,
      });
    });
    setCityList(cities);
  }, [userAttributes]);

  useEffect(() => {
    const states = { ...initialState };
    if (isValNull(activeFilters.city_id)) {
      if (cityList && cityList.length == 1) {
        states.city = cityList[0];
        setEntityList(cityList[0].zones);
      }
    }
    if (isValNull(activeFilters.entity_type)) {
      states.entity_type =
        entityTypeList.length == 1 ? entityTypeList[0].entity_type : "";
    }
    if (isValNull(activeFilters)) {
      setInitialState(states);
    }
  }, [cityList, entityTypeList]);

  const handleFilterChange = (key, value) => {
    const values = { ...initialState };
    values[key] = value;
    if (key == "city") {
      cityList.map((city) => {
        if (city.id === value?.id) {
          setEntityList(city.zones);
        }
      });
      values["entity"] = {};
    } else if (key == "start_date") {
      values.end_date = "";
    }
    setInitialState(values);
    setActiveFilters({
      ...values,
      entity_type: getId("entity_type", values.entity_type),
    });
  };

  const getId = (key, val) => {
    if (key === "entity_type") {
      const activeEntityType = entityTypeList.find(
        (item) => item.entity_type === val
      );
      return activeEntityType ? activeEntityType.id : "";
    } else {
      return val;
    }
  };

  const getValue = (key, val) => {
    if (key === "city") {
      const activeCity = cityList.find((item) => item.id === val);
      return activeCity ? activeCity : {};
    } else if (key === "entity") {
      const activeEntityName = entityList.find((item) => item.zone_id === val);
      return activeEntityName ? activeEntityName : {};
    } else if (key === "entity_type") {
      const activeEntityType = entityTypeList.find((item) => item.id === val);
      return activeEntityType ? activeEntityType.entity_type : "";
    } else if (key === "carrier") {
      const activeCarrier = carrierList.find((item) => item.id === val);
      return activeCarrier ? activeCarrier.carrier_type : "";
    } else {
      return val;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const pageRequest = { page: 1 };
    const newState = {
      ...initialState,
      entity_ids: [initialState.entity.zone_id],
      sort_order: getSortOrder(),
    };
    if (!isValNull(initialState.carrier_type)) {
      newState["carrier_types"] = [initialState.carrier_type];
    } else {
      newState["carrier_types"] = carrierList.reduce(
        (carrierTypes, currentCarrier) => {
          carrierTypes.push(currentCarrier.id);
          return carrierTypes;
        },
        []
      );
    }
    getCapacityChangeRequests(newState, pageRequest).then((res) => {
      if (res) {
        handleModalClose();
      }
    });
    resetPageCount();
  };

  const getSortOrder = () => {
    if (
      allMenuActions.hasOwnProperty(allActions.APPROVE) &&
      allMenuActions[allActions.APPROVE]
    ) {
      return "asc";
    } else {
      return "desc";
    }
  };

  const clearFilters = () => {
    resetStateSlot({ state: "activeFilters" });
    setInitialState({
      city: {},
      entity_type: "",
      status: "",
      start_date: moment(new Date()).format("YYYY-MM-DD"),
      end_date: moment(new Date()).add(4, "days").format("YYYY-MM-DD"),
      request_id: "",
      entity: {},
      carrier_type: "",
      date: "",
    });
  };

  const checkIfButtonDisabled = (type) => {
    if (type === "apply") {
      return (
        !isObjectAllEntriesPresent(
          filterObj(initialState, [
            "entity_type",
            "start_date",
            "end_date",
            "city",
            "status",
            "entity",
          ])
        ) && isValNull(initialState.request_id)
      );
    } else {
      return isObjectStateEmpty(initialState);
    }
  };

  return (
    <div className="set-banner-modal" id="bannerUpload">
      <NoFooterModal
        handleClose={handleModalClose}
        heading={"Filters"}
        id={"capacityChangeApprovalFilters"}
        header={true}
        modalButtons={
          <BottomSectionModal className="flex items-center justify-between">
            <Button
              data-testid="clearButton"
              onClick={clearFilters}
              className="sushi-btn"
              appearance="outline"
            >
              Clear
            </Button>
            <Button
              disabled={checkIfButtonDisabled("apply")}
              data-testid="submitButton"
              onClick={handleSubmit}
              className="sushi-btn"
            >
              Apply
            </Button>
          </BottomSectionModal>
        }
      >
        <div className="flex items-center justify-between">
          <Label style={{ width: "25%" }} className="semibold mb-10">
            City Name
          </Label>
          <Autocomplete
            style={{ flexGrow: 1 }}
            value={initialState.city}
            onChange={(event, newValue) => {
              handleFilterChange("city", newValue);
            }}
            data-testid="city"
            id="setCity"
            options={cityList}
            getOptionLabel={(option) => option.name}
            autoComplete
            renderInput={(params) => (
              <TextField {...params} label="City" variant="outlined" />
            )}
          />
        </div>
        <div className="flex items-center justify-between">
          <Label style={{ width: "25%" }} className="semibold mb-10">
            Entity Type
          </Label>
          <PaginatedReactDropdown
            key={`entityType${initialState.entity_type}`}
            options={entityTypeList}
            labelKey="entity_type"
            valueKey="entity_type"
            id={`entityType${initialState.entity_type}`}
            optionsBoxId="entity_type_options_box"
            value={initialState.entity_type}
            handleChange={handleFilterChange}
            keyToChange={"entity_type"}
            placeholder=""
          />
        </div>
        <div className="flex items-center justify-between">
          <Label style={{ width: "25%" }} className="semibold mb-10">
            Entity Name
          </Label>
          <Autocomplete
            style={{ flexGrow: 1 }}
            value={initialState.entity}
            disabled={isValNull(initialState.city)}
            onChange={(event, newValue) => {
              handleFilterChange("entity", newValue);
            }}
            id={`entityName${initialState.entity_id}`}
            options={entityList}
            getOptionLabel={(option) => option.zone_name}
            autoComplete
            renderInput={(params) => (
              <TextField {...params} label="Entity Name" variant="outlined" />
            )}
          />
        </div>
        <div className="flex items-center justify-between">
          <Label style={{ width: "25%" }} className="semibold mb-10">
            Carrier
          </Label>
          <PaginatedReactDropdown
            options={carrierList}
            labelKey="carrier_type"
            valueKey="id"
            id={`carrierName${initialState.carrier_type}`}
            key={`carrierName${initialState.carrier_type}`}
            optionsBoxId="entity_name_options_box"
            value={getValue("carrier", initialState.carrier_type)}
            handleChange={handleFilterChange}
            keyToChange={"carrier_type"}
            placeholder="(optional)"
            showCross
          />
        </div>
        <div className="flex items-center justify-between">
          <Label style={{ width: "25%" }} className="semibold mb-10">
            Status
          </Label>
          <PaginatedReactDropdown
            key={`status${initialState.city_id}`}
            options={REQUEST_STATUSES}
            labelKey="label"
            valueKey="label"
            id={`cityName${initialState.city_id}`}
            optionsBoxId="city_options_box"
            value={initialState.status}
            handleChange={handleFilterChange}
            keyToChange={"status"}
            placeholder=""
            showCross
          />
        </div>
        <div className="flex items-center justify-start">
          <Label style={{ width: "25%" }} className="semibold mb-10">
            Start Date
          </Label>
          <Input
            type="date"
            id="sushi-input"
            data-testid="start_date"
            fullWidth={false}
            label="Start Date"
            value={initialState.start_date ? initialState.start_date : " "}
            onChange={(e) => handleFilterChange("start_date", e)}
          />
        </div>
        <div className="flex items-center justify-start">
          <Label style={{ width: "25%" }} className="semibold mb-10">
            End Date
          </Label>
          <Input
            type="date"
            id="sushi-input"
            data-testid="end_date"
            fullWidth={false}
            label="End Date"
            value={initialState.end_date ? initialState.end_date : " "}
            onChange={(e) => handleFilterChange("end_date", e)}
            min={initialState.start_date}
          />
        </div>
        <div className="flex items-center justify-between">
          <Label style={{ width: "25%" }} className="semibold mb-10">
            Request Id
          </Label>
          <Input
            style={{ width: "75%" }}
            id="sushi-input"
            data-testid="request_id"
            label="Request Id"
            value={initialState.request_id}
            onChange={(e) => handleFilterChange("request_id", e)}
            type="number"
          />
        </div>
      </NoFooterModal>
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    setEntityList: bindActionCreators(setEntityList, dispatch),
    setActiveFilters: bindActionCreators(setActiveFilters, dispatch),
    getCapacityChangeRequests: bindActionCreators(
      getCapacityChangeRequestData,
      dispatch
    ),
    resetStateSlot: bindActionCreators(resetStateSlot, dispatch),
  };
}

function mapStateToProps(state) {
  const { User, CapacityChange, MenuActions } = state;
  return {
    activeFilters: CapacityChange.activeFilters,
    isLoading: User.isLoading,
    entityList: CapacityChange.entityList,
    allMenuActions: MenuActions.allMenuActions,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewFilters);
